import { apiPost } from './client';

export interface PromoCodeValidation {
  code: string;
  type: 'percentage' | 'fixed';
  value: number;
  discount: number;
  description: string;
  minAmount?: number;
  maxDiscount?: number;
}

export interface PromoCodeValidationResponse {
  success: boolean;
  message: string;
  data: PromoCodeValidation;
}

export interface CreateOrderData {
  eventId: string;
  ticketType: string;
  quantity: number;
  totalAmount: number;
  discount: number;
  finalAmount: number;
  paymentMethod: string;
  promoCode?: string;
  billingInfo: {
    firstName?: string;
    lastName?: string;
    name?: string;
    email: string;
    phone: string;
    address?: string;
    city?: string;
    country?: string;
    zipCode?: string;
  };
  deliveryInfo?: {
    method?: string;
    address?: string;
    city?: string;
    notes?: string;
  };
}

export interface PaymentOrder {
  id: string;
  orderNumber: string;
  totalAmount: number;
  discount: number;
  finalAmount: number;
  paymentMethod: string;
  paymentStatus: string;
  createdAt: string;
  event: {
    id: string;
    title: string;
    date: string;
    time: string;
    venue: string;
    image: string;
  };
  tickets: Array<{
    id: string;
    ticketNumber: string;
    qrCode: string;
    status: string;
    ticketType: string;
    price: number;
  }>;
}

export interface CreateOrderResponse {
  success: boolean;
  message: string;
  data: {
    order: PaymentOrder;
  };
}

export const paymentsApi = {
  // Validate promo code
  validatePromoCode: (code: string, amount?: number): Promise<PromoCodeValidationResponse> => {
    return apiPost('/promo-codes/validate', { code, amount });
  },

  // Create order
  createOrder: (data: CreateOrderData): Promise<CreateOrderResponse> => {
    return apiPost('/orders', data);
  },
};


